var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6016 62.8984L71.1016 25.3984L65.2422 19.3438L33.6016 50.9844L18.7578 36.1406L12.8984 42L33.6016 62.8984ZM12.5078 12.7031C20.7109 4.5 30.5417 0.398438 42 0.398438C53.4583 0.398438 63.224 4.5 71.2969 12.7031C79.5 20.776 83.6016 30.5417 83.6016 42C83.6016 53.4583 79.5 63.2891 71.2969 71.4922C63.224 79.5651 53.4583 83.6016 42 83.6016C30.5417 83.6016 20.7109 79.5651 12.5078 71.4922C4.4349 63.2891 0.398438 53.4583 0.398438 42C0.398438 30.5417 4.4349 20.776 12.5078 12.7031Z",
    fill: "#00CC99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrder);
export default __webpack_public_path__ + "static/media/check-order.31ceb7e0.svg";
export { ForwardRef as ReactComponent };